import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LabelPrintService } from '@app/shared/services/label-print.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
@Component({
  selector: 'app-label-print-list',
  templateUrl: './label-print-list.component.html',
  styleUrls: ['./label-print-list.component.css']
})
export class LabelPrintListComponent implements OnInit {
  labelPrintList: any[] = [];
  searchText: string = '';
  fromDate: string = '';
  toDate: string = '';
  
  constructor(
    private labelPrintService: LabelPrintService,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getAllPrintLabelList();
  }
  getAllPrintLabelList() {
    this.labelPrintService.getLabelPrint().subscribe(
      (response: any[]) => {
        this.labelPrintList = response.reverse().map(label => {
          // Sort the rows inside each label by descending rollNo suffix
          label.row = label.row.sort((a, b) => {
            const getSuffixNumber = (rollNo: string) => {
              const match = rollNo?.match(/-(\d+)$/);
              return match ? parseInt(match[1], 10) : 0;
            };
            return getSuffixNumber(b.rollNo) - getSuffixNumber(a.rollNo); // Descending
          });
          return label;
        });
  
        console.log('Sorted label print list:', this.labelPrintList);
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching label print list:', error);
      }
    );
  }
  
 get filteredLabels() {
  let filtered = this.labelPrintList;

  const lowerSearch = this.searchText.toLowerCase();

  // Apply search text filter
  if (this.searchText) {
    filtered = filtered.filter(label => {
      const ticketMatch = label.ticketNo?.toLowerCase().includes(lowerSearch);
      const widthMatch = label.width?.toString().toLowerCase().includes(lowerSearch);
      const dateMatch = label.date?.toLowerCase().includes(lowerSearch);
      return ticketMatch || widthMatch || dateMatch;
    });
  }

  // Apply date range filter
  if (this.fromDate && this.toDate) {
    const from = new Date(this.fromDate);
    const to = new Date(this.toDate);

    filtered = filtered.filter(label => {
      const labelDate = new Date(label.date);
      return labelDate >= from && labelDate <= to;
    });
  }

  return filtered;
}

  
// previous correct one in browser
  // print(labelId: string) {
  //   const label = this.labelPrintList.find(d => d._id === labelId);
  
  //   if (!label) {
  //     console.error("Label not found!");
  //     return;
  //   }
  
  //   const doc = new jsPDF();
  
  //   // Load and add the logo image
  //   //const logoUrl = 'https://lexipackghana.com/assets/images/logo/logo.png';
  //   //const img = new Image();
  //  // img.crossOrigin = 'Anonymous'; // To avoid CORS issues
  
  //  // img.onload = () => {
  //   //  doc.addImage(img, 'PNG', 10, 10, 50, 20); // (img, format, x, y, width, height)
  //     doc.setFontSize(14);
  //     doc.text('Label Print', 105, 20, { align: 'center' });
  
  //     let finalY = 25;
  
  //     // Add ticket number
  //     autoTable(doc, {
  //       startY: finalY,
  //       head: [['Ticket Number', label.ticketNo]],
  //       theme: 'grid',
  //       styles: { fontSize: 12 },
  //      // headStyles: { fillColor: [240, 240, 240] },
  //       columnStyles: {
  //         0: { cellWidth: 50 },
  //         1: { cellWidth: 130 }
  //       },
  //       tableWidth: 190
  //     });
  
  //     finalY = doc.lastAutoTable.finalY + 2;
  
  //     // Loop through rows
  //     label.row.forEach((row: any, index: number) => {
  //       autoTable(doc, {
  //         startY: finalY,
  //         body: [
  //           ['Job Name', { content: label.jobName || 'N/A', colSpan: 3 }],
  //           ['Date', label.date || 'N/A', 'Width', label.width || 'N/A'],
  //           ['Roll Number', row.rollNo || 'N/A', 'Net Wet', row.netwet || 'N/A'],
  //           ['JTK / Batch', { content: label.batch || 'N/A', colSpan: 3 }]
  //         ],
  //         theme: 'grid',
  //         styles: { fontSize: 12 },
  //         columnStyles: {
  //           0: { cellWidth: 50 },
  //           1: { cellWidth: 40 },
  //           2: { cellWidth: 50 },
  //           3: { cellWidth: 50 }
  //         },
  //         tableWidth: 190,
  //         didDrawPage: () => {
  //           // Optional: Add headers/footers here
  //         }
  //       });
  
  //       finalY = doc.lastAutoTable.finalY + 5; // Add spacing after each block
  //     });
  
  //     // Save or open the PDF
  //     const pdfBlob = doc.output('blob');
  //     const blobUrl = URL.createObjectURL(pdfBlob);
  //     window.open(blobUrl);
    
  //   };
  
   // img.src = logoUrl;
  //}



  // with download and then print
  // print(id: string) {
  //   this.labelPrintService.printLabel(id).subscribe((res: any) => {
  //     const url = window.URL.createObjectURL(res);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     // a.download = `Label_${id}.pdf`;
  //     a.click();
  //   }, (err) => {
  //     console.error('Print error:', err);
  //   });
  // }
  // directly browser printing
  print(id: string) {
  this.labelPrintService.printLabel(id).subscribe((res: any) => {
    const url = window.URL.createObjectURL(res);
    const newTab = window.open(url, '_blank'); // Open in new tab
    if (!newTab) {
      console.error('Failed to open a new tab');
    }
  }, (err) => {
    console.error('Print error:', err);
  });
}




  // print(labelId: string) {
  //   const label = this.labelPrintList.find(d => d._id === labelId);
  
  //   if (!label) {
  //     console.error("Label not found!");
  //     return;
  //   }
  
  //   const doc = new jsPDF();
  //   doc.setFontSize(12);
  //   let y = 10; // starting y position
  
  //   label.row.forEach((row, index) => {
  //     // Add Job Name, Date, Width
  //     doc.text(`Job Name: ${label.jobName}`, 10, y);
  //     y += 6;
  //     doc.text(`Date: ${new Date(label.date).toLocaleDateString('en-GB')}  Width: ${label.width}`, 10, y);
  //     y += 6;
  //     // Add Roll Number, Net Wet
  //     doc.text(`Roll Number: ${row.rollNo}  Net Wet: ${row.netwet}`, 10, y);
  //     y += 6;
  //     // Add JTK / Batch
  //     doc.text(`JTK / Batch: ${label.batch}`, 10, y);
  //     y += 10; // extra spacing between labels
  
  //     // Optional: add page break if near bottom of page
  //     if (y > 270) { 
  //       doc.addPage();
  //       y = 10;
  //     }
  //   });
  
  //   // Open the PDF in new tab
  //   const pdfBlob = doc.output('blob');
  //   const url = window.URL.createObjectURL(pdfBlob);
  //   window.open(url);
  // }
  
  
  
}



// print(labelId: string) {
  //   const label = this.labelPrintList.find(d => d._id === labelId);
  
  //   if (label) {
  //     // Open a new tab
  //     const printTab = window.open('', '_blank');
      
  //     if (printTab) {
  //       // Create print content asynchronously to avoid blocking the UI
  //       setTimeout(() => {
  //         // Build table rows dynamically for each row in label.row
  //         let rowsHtml = '';
  //         label.row.forEach((row: any, index: number) => {
  //           // Add the row data
  //           rowsHtml += `
  //             <tr>
  //               <th>Job Name</th>
  //               <td colspan="3">${label.jobName || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>Date</th>
  //               <td>${label.date || 'N/A'}</td>
  //               <th>Width</th>
  //               <td>${label.width || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>Roll Number</th>
  //               <td>${row.rollNo || 'N/A'}</td>
  //               <th>Net Wet</th>
  //               <td>${row.netwet || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>JTK / Batch</th>
  //               <td colspan="3">${label.batch || 'N/A'}</td>
  //             </tr>
  //           `;
            
  //           // Add a gap (empty row) after the first row data
  //           if (index !== label.row.length - 1) {
  //             rowsHtml += `
  //               <tr><td colspan="4" style="height: 20px;"></td></tr>
  //             `;
  //           }
  //         });
  
  //         // Construct the full HTML content
  //         const printContent = `
  //           <html>
  //           <head>
  //             <style>
  //               /* Styles for the printed content */
  //               .container {
  //                 width: 900px;
  //               }
  //               .table {
  //                 width: 100%;
  //                 margin: 0;
  //                 border-collapse: collapse;
  //                 text-align:left;
  //               }
  //               .table td, .table th {
  //                 border: 1px solid #000;
  //                 padding: 5px 10px;
  //               }
  //               .table th {
  //                 background-color: #f2f2f2;
  //               }
  //               .logo {
  //                 width: 150px;
  //                 height: auto;
  //                 margin: 20px 0;
  //               }
  //               /* Add some space between rows */
  //               tr {
  //                 margin-bottom: 20px; /* Adjust the value as needed */
  //               }
  //             </style>
  //           </head>
  //           <body>
  //             <div>
  //               <img class="logo" src="https://lexipackghana.com/assets/images/logo/logo.png" alt="Company Logo" />
  //               <h3 style="text-align:center;">Label Print</h3>
  //             </div>
  //             <div class="container">
  //               <table class="table">
  //                 <thead>
  //                   <tr>
  //                     <th>Ticket Number</th>
  //                     <td colspan="3">${label.ticketNo}</td>
  //                   </tr>
  //                   <!-- Iterate through the rows and print each row data -->
  //                   ${rowsHtml}
  //                 </thead>
  //               </table>
  //             </div>
  //           </body>
  //           </html>
  //         `;
  
  //         // Write the content to the new tab
  //         printTab.document.write(printContent);
  //         printTab.document.close(); // Close the document stream for printing
  //         printTab.focus(); // Focus the new tab
  
  //         // Now you can trigger the print action
  //         printTab.print();
  //         printTab.close(); // Optionally, close the tab after printing
  //       }, 0); // Set timeout to avoid blocking the main thread immediately
  //     }
  //   } else {
  //     console.error("Label not found!");
  //   }
  // }
  
  // print(labelId: string) {
  //   const label = this.labelPrintList.find(d => d._id === labelId);

  //   if (label) {
  //     const printWindow = window.open('', '_blank');
  //     if (printWindow) {
  //       // Create print content asynchronously to avoid blocking the UI
  //       setTimeout(() => {
  //         // Build table rows dynamically for each row in label.row
  //         let rowsHtml = '';
  //         label.row.forEach((row: any, index: number) => {
  //           // Add the row data
  //           rowsHtml += `
  //             <tr>
  //               <th>Job Name</th>
  //               <td colspan="3">${label.jobName || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>Date</th>
  //               <td>${label.date || 'N/A'}</td>
  //               <th>Width</th>
  //               <td>${label.width || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>Roll Number</th>
  //               <td>${row.rollNo || 'N/A'}</td>
  //               <th>Net Wet</th>
  //               <td>${row.netwet || 'N/A'}</td>
  //             </tr>
  //             <tr>
  //               <th>JTK / Batch</th>
  //               <td colspan="3">${label.batch || 'N/A'}</td>
  //             </tr>
  //           `;
            
  //           // Add a gap (empty row) after the first row data
  //           if (index !== label.row.length - 1) {
  //             rowsHtml += `
  //               <tr><td colspan="4" style="height: 20px;"></td></tr>
  //             `;
  //           }
  //         });

  //         // Construct the full HTML content
  //         const printContent = `
  //           <html>
  //           <head>
  //             <style>
  //               /* Styles for the printed content */
  //               .container {
  //                 width: 900px;
  //               }
  //               .table {
  //                 width: 100%;
  //                 margin: 0;
  //                 border-collapse: collapse;
  //                 text-align:left;
  //               }
  //               .table td, .table th {
  //                 border: 1px solid #000;
  //                 padding: 5px 10px;
  //               }
  //               .table th {
  //                 background-color: #f2f2f2;
  //               }
  //               .logo {
  //                 width: 150px;
  //                 height: auto;
  //                 margin: 20px 0;
  //               }
  //               /* Add some space between rows */
  //               tr {
  //                 margin-bottom: 20px; /* Adjust the value as needed */
  //               }
  //             </style>
  //           </head>
  //           <body>
  //             <div>
  //               <img class="logo" src="https://lexipackghana.com/assets/images/logo/logo.png" alt="Company Logo" />
  //               <h3 style="text-align:center;">Label Print</h3>
  //             </div>
  //             <div class="container">
  //               <table class="table">
  //                 <thead>
  //                   <tr>
  //                     <th>Ticket Number</th>
  //                     <td colspan="3">${label.ticketNo}</td>
  //                   </tr>
  //                   <!-- Iterate through the rows and print each row data -->
  //                   ${rowsHtml}
  //                 </thead>
  //               </table>
  //             </div>
  //           </body>
  //           </html>
  //         `;

  //         // Print the content
  //         printWindow.document.write(printContent);
  //         printWindow.focus();
  //         printWindow.print();
  //         printWindow.close();
  //       }, 0); // Set timeout to avoid blocking the main thread immediately
  //     }
  //   } else {
  //     console.error("Label not found!");
  //   }
  // }
  
// get filteredLabels() {
//   if (!this.searchText) return this.labelPrintList;

//   const lowerSearch = this.searchText.toLowerCase();
//   return this.labelPrintList.filter(label =>
//     (label.ticketNo && label.ticketNo.toLowerCase().includes(lowerSearch)) ||
//     (label.width && label.width.toLowerCase().includes(lowerSearch)) 
//     // ||
//     // label.row.some(row =>
//     //   (row.rollNo && row.rollNo.toLowerCase().includes(lowerSearch))
//     // )
//   );
// }
  